import { DocumentNode } from '@apollo/client';
import { useApiMutation } from '@common/hooks';
import DataService from '@core/services/DataService';
import { getGenericLine } from '@utils/helper-utils';

import {
  downloadGroupMedicalCertificates,
  downloadFleetCertificatesDetails,
  downloadGroupFleetMarineCertificatesDetails
} from '../services';

import { GenericLines } from 'src/enums/line.enums';

interface DownloadCertificatesVariables {
  id?: string;
}

export function useDownloadCertificates(lineCode: string) {
  const isGroupMedical =
    getGenericLine(lineCode) === GenericLines.MEDICAL_GROUP;

  const isFleetLine = [4, 51].includes(Number(lineCode));
  const isMarine = getGenericLine(lineCode) === GenericLines.MARINE;
  // Select mutation dynamically
  const selectQuery = (): DocumentNode => {
    switch (true) {
      case isGroupMedical:
        return downloadGroupMedicalCertificates;

      case isFleetLine:
        return downloadFleetCertificatesDetails;

      case isMarine:
        return downloadGroupFleetMarineCertificatesDetails;

      default:
        return downloadGroupMedicalCertificates;
    }
  };

  const selectedQuery = selectQuery();

  const [downloadApi] = useApiMutation<any, DownloadCertificatesVariables>(
    selectedQuery,
    'downloadCertificates',
    { withLoader: false }
  );

  const downloadDocument = async (
    variables?: DownloadCertificatesVariables
  ): Promise<void | null> => {
    if (!selectedQuery) return null;

    try {
      const response = await downloadApi(variables);

      const file =
        response?.data?.production?.[Object.keys(response.data.production)[0]];

      if (!file?.content) return null;

      DataService.downloadBase64File(
        file.content,
        file.contentType,
        file.fileName
      );
    } catch (err) {
      console.error('Error downloading document:', err);
      return null;
    }
  };

  return downloadDocument;
}
